import React from "react";
import { Row, Col, Button } from "reactstrap";

const BudgetRow = (props) => {


    const deleteBudget = (budgetId) => {
        console.log('remove budget', budgetId);
        props.removeHandler(budgetId);
    }

    return (<>
        <Row className="p-3">
            <Col md="8" xs="8">
                {props.domain}
            </Col>
            <Col md="2" xs="2">
                ${props.budget}
            </Col>
            <Col md="2" xs="2">
                <Button onClick={() => deleteBudget(props.id)} color="danger" style={{margin: "0px"}}>
                    <i className="now-ui-icons ui-1_simple-remove" />
                </Button>
            </Col>
        </Row>
    </>);

}
export default BudgetRow;

